// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__12fxx","upload":"Small_upload__3potL","imageWrap":"Small_imageWrap__3wbhL","removeBtn":"Small_removeBtn__xeqC7"};